import $script from 'scriptjs';

let promise;

export function loadGrecaptchaApi() {
    return promise ? promise : promise = new Promise((resolve) => {
        window.grecaptchaLoaded = () => resolve(window.grecaptcha);
        $script('https://www.google.com/recaptcha/api.js?onload=grecaptchaLoaded&render=explicit');
    });
}



// WEBPACK FOOTER //
// ./src/portal/components/captcha/sp-grecaptcha/load-grecaptcha-api.js